import { useIsDesktop } from '@cian/valuation-utils-component';
import * as React from 'react';
import { useDispatch } from 'react-redux';

import { getOffersHistory, openOfferFromHistory, setCategoriesFilter, setPage } from '../../../actions/offersHistory';
import { FILTER_ALL_VALUE, TCategoriesFilterOptionValue } from '../../../types/offerHistory';
import { TThunkDispatch } from '../../../types/redux';
import { trackFiltersChange } from '../Desktop/analytics';

export const useHandleCategoriesFiltersClick = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const isDesktop = useIsDesktop();

  return React.useCallback(
    async (_: React.ChangeEvent, value: string) => {
      const _value = value as TCategoriesFilterOptionValue;

      dispatch(setCategoriesFilter(_value === FILTER_ALL_VALUE ? FILTER_ALL_VALUE : _value));

      dispatch(setPage(1));
      await dispatch(getOffersHistory(false));
      dispatch(trackFiltersChange());

      /** Для десктопа сразу после смены категории открываем объявление */
      if (isDesktop) {
        await dispatch(openOfferFromHistory());
      }
    },
    [dispatch, isDesktop],
  );
};
